/**
 * URL base da API.
 * Em desenvolvimento: usa URL direta do backend (evita problemas de proxy/porta)
 * Em produção: use VITE_API_URL no .env (ex: https://api.seudominio.com/api)
 * Em HTTPS: nunca usar http:// para evitar "conteúdo ativo com erros de certificado".
 */
function getApiBase() {
  const raw = import.meta.env.VITE_API_URL
    || (import.meta.env.DEV ? 'http://localhost:3001/api' : '/api');
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && String(raw).startsWith('http://')) {
    return raw.replace(/^http:\/\//, 'https://');
  }
  return raw;
}
export const API_BASE = getApiBase();

/** URL pública de um arquivo em /uploads a partir do caminho salvo no banco. */
export function uploadsPublicUrl(urlPath) {
  if (!urlPath) return '';
  if (/^https?:\/\//i.test(urlPath)) return urlPath;
  const origin = String(API_BASE).replace(/\/api\/?$/, '');
  return origin + (String(urlPath).startsWith('/') ? urlPath : `/${urlPath}`);
}
